import { render, staticRenderFns } from "./CardSchedule.vue?vue&type=template&id=36508880"
import script from "./CardSchedule.vue?vue&type=script&lang=js"
export * from "./CardSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports